import { MenubarCheckboxItem } from "@/components/ui/menubar";
import useSimpleLocalStorage from "@/hooks/useSimpleLocalStorage";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function useShowDeletedToggle(storageKey: string, enabled = true) {
  const { t } = useTranslation();
  const [includeDeleted, setIncludeDeleted] = useSimpleLocalStorage<boolean>(
    `table:includeDeleted:${storageKey}`,
    false,
  );

  const active = enabled && includeDeleted;

  const queryParams = useMemo(
    () => (active ? { include_deleted: "true" } : undefined),
    [active],
  );

  const toggleItem = enabled ? (
    <MenubarCheckboxItem
      checked={includeDeleted}
      onCheckedChange={setIncludeDeleted}
      onSelect={(event) => event.preventDefault()}
    >
      {t("listMenubar.settings.includeDeleted")}
    </MenubarCheckboxItem>
  ) : null;

  return {
    includeDeleted,
    setIncludeDeleted,
    queryKeyExtras: queryParams,
    queryParams,
    toggleItem,
  };
}
